import { render, staticRenderFns } from "./DetalhesMonitoramento.vue?vue&type=template&id=1f6ba98a&scoped=true&lang=pug"
import script from "./DetalhesMonitoramento.vue?vue&type=script&lang=js"
export * from "./DetalhesMonitoramento.vue?vue&type=script&lang=js"
import style0 from "./DetalhesMonitoramento.vue?vue&type=style&index=0&id=1f6ba98a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f6ba98a",
  null
  
)

export default component.exports